export class PeoplefoneBundle {
  type: String;
  spec: String;
  numbersPorting: String;
  router: String;
  routerCostUnique: number;
  costMonthly: number;
  costUnique: number;

  constructor() {
    this.type = '';
    this.spec = '';
    this.router = '';
    this.routerCostUnique = 0;
    this.numbersPorting = null;
    this.costMonthly = 0;
    this.costUnique = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/PeoplefoneBundle.ts